import { css, cx } from "@emotion/css"
import { useMemo } from "react"

import Button from "@p-ban/common/src/components/html/Button"

import Spinner from "../../../../../../components/ui/Spinner/Spinner"

type Props = {
  onClick?: () => void
  children: string
  disabled?: boolean
  isLoading?: boolean
  width?: number
  backgroundColor: string
  id?: string
}

const StyledButton = ({
  onClick,
  disabled = false,
  isLoading = false,
  children,
  width,
  backgroundColor,
  id = "",
}: Props) => {
  const style = useMemo(() => {
    return css`
      position: relative;
      width: ${width === undefined ? "100%" : `${width}px`};
      height: 36px;
      padding-bottom: 3px;
      font-size: 16px;
      color: white;
      text-align: center;
      background-color: ${backgroundColor};
      border: 0;
      border-radius: 5px;
      margin-bottom: 10px;
    `
  }, [backgroundColor, width])

  return (
    <Button
      className={cx(style, disabled && disabledStyle, isLoading && hoverStyle)}
      hoverClassName={disabled ? undefined : hoverStyle}
      disabled={disabled || isLoading}
      onClick={onClick}
      id={id}
      data-ga4-measure-click="" // google analyticsタグ
    >
      {isLoading && (
        <span className={spinnerContainer}>
          <Spinner size="small" color="white" />
        </span>
      )}
      {children}
    </Button>
  )
}

export default StyledButton

const disabledStyle = css`
  background-color: gray;
  border: 2px solid gray;
`
const hoverStyle = css`
  opacity: 0.7;
`

const spinnerContainer = css`
  position: absolute;
  top: 8px;
  left: 5px;
`
